<template>
  <div>
    <PageGrundData v-model="meta" />
    <PlaceInBubble v-model="meta" />

    <v-select
      :items="themeOptions"
      v-model="pageTheme"
      label="Tema"
      outlined
      return-object
      item-text="title"
      item-value="id"
      class="mb-3"
      hint="Vilket tema ska den här sidan använda?"
      persistent-hint
    ></v-select>
    <v-text-field outlined label="Sidnamn" v-model="title"></v-text-field>
    <v-textarea outlined label="Pufftext" v-model="preamble"></v-textarea>
    <slot :name="THEME_HU"></slot>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Banner-bild </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ImageComponent v-model="image" label="Banner-bild" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Nyckelord </v-expansion-panel-header>
        <v-expansion-panel-content> <Keywords v-model="keywords" /> </v-expansion-panel-content
      ></v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
/* eslint camelcase: 0 */
import pageTemplates, { THEME_HAVET, THEME_LIVET, THEME_HU } from '@/assets/data/pageTemplates'
import Keywords from '../shared/Keywords'
import ImageComponent from '@/components/shared/Image'
import PageGrundData from './PageGrundData'
import PlaceInBubble from '@/components/shared/PlaceInBubble'
import { defaultPageMetaData } from '@/assets/data/metaData.js'

export default {
  name: 'TemplatePageStandard',
  props: {
    page_menu_title: {
      type: String,
    },
    page_image: {
      type: String,
    },
    page_template: {
      type: String,
    },
    page_description: {
      type: String,
    },
    page_keywords: {
      type: String,
    },
    page_section: {
      type: String,
    },
    page_meta: {
      type: String,
    },
  },
  components: {
    Keywords,
    ImageComponent,
    PageGrundData,
    PlaceInBubble,
  },
  data() {
    return { THEME_HAVET, THEME_LIVET, THEME_HU }
  },
  computed: {
    themeOptions() {
      return pageTemplates
    },
    title: {
      get() {
        return this.page_menu_title
      },
      set(val) {
        const _val = val ? val.trim() : ''
        this.$emit('update', { page_menu_title: _val })
      },
    },
    preamble: {
      get() {
        return this.page_description
      },
      set(val) {
        this.$emit('update', { page_description: val })
      },
    },
    image: {
      get() {
        return !Number.isNaN(this.page_image)
          ? `${process.env.VUE_APP_IMAGE_BACKEND}/870/${this.page_image}.jpg`
          : this.page_image
      },
      set(val) {
        this.$emit('update', { page_image: val.toString() })
      },
    },
    pageTheme: {
      get() {
        if (this.page_template) {
          return pageTemplates.find((t) => t.id === this.page_template)
            ? pageTemplates.find((t) => t.id === this.page_template)
            : 'HavetStandard'
        }
        switch (this.page_section) {
          case 'havet':
            return 'HavetStandard'
          case 'livet':
            return 'LivetStandard'
          case 'havsutsikt':
            return 'HavsutsiktStandard'
          default:
            return 'HavetStandard'
        }
      },
      set({ id }) {
        if (id === 'havet') {
          this.$emit('update', { page_template: null })
          return
        }
        this.$emit('update', { page_template: id })
      },
    },
    keywords: {
      get() {
        return this.page_keywords
          ? this.page_keywords
              .replaceAll(',', ' ')
              .split(' ')
              .map((w) => w.trim())
              .filter((w) => w.length > 0)
              .join(' ')
          : ''
      },
      set(val) {
        this.$emit('update', { page_keywords: val })
      },
    },
    meta: {
      get() {
        try {
          if (!this.page_meta) {
            return defaultPageMetaData
          }
          const meta = JSON.parse(this.page_meta)
          return { ...defaultPageMetaData, ...meta }
        } catch (error) {
          return defaultPageMetaData
        }
      },
      set(val) {
        this.$emit('update-immediately', { page_meta: val })
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
